var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.5,
    r: 12.5,
    fill: "#F5F5F5",
    stroke: "#616161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2023 7.49922C13.8623 7.49922 14.4023 8.03922 14.4023 8.69922V13.4992C14.4023 14.1592 13.8623 14.6992 13.2023 14.6992C12.5423 14.6992 12.0023 14.1592 12.0023 13.4992V8.69922C12.0023 8.03922 12.5423 7.49922 13.2023 7.49922Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0062 18.3C12.0062 17.6373 12.5435 17.1 13.2062 17.1C13.869 17.1 14.4062 17.6373 14.4062 18.3C14.4062 18.9627 13.869 19.5 13.2062 19.5C12.5435 19.5 12.0062 18.9627 12.0062 18.3Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorGrey);
export default __webpack_public_path__ + "static/media/Icon_Error_Grey.efd0159c8d41e811edc89ff2e0a6fb52.svg";
export { ForwardRef as ReactComponent };